import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BehavioralPatternImageModule } from '../../core-ui/BehavioralPatternImage/BehavioralPatternImage.module';
import { BehavioralRangesRectanglesModule } from '../../core-ui/BehavioralRangesRectangles/BehavioralRangesRectangles.module';
import { BehavioralRangesComponent } from './BehavioralRanges.component';

export const BehavioralRangesModuleExports = [BehavioralRangesComponent];

@NgModule({
    imports: [
        CommonModule,
        BehavioralPatternImageModule,
        BehavioralRangesRectanglesModule
    ],
    declarations: [...BehavioralRangesModuleExports],
    exports: [...BehavioralRangesModuleExports],
    providers: []
})
export class BehavioralRangesModule {}
